import { render, staticRenderFns } from "./CreateApiKey.vue?vue&type=template&id=b5a755e0&scoped=true"
import script from "./CreateApiKey.vue?vue&type=script&lang=js"
export * from "./CreateApiKey.vue?vue&type=script&lang=js"
import style0 from "./CreateApiKey.vue?vue&type=style&index=0&id=b5a755e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a755e0",
  null
  
)

export default component.exports